<script setup>

import { ref, watch, onMounted } from 'vue';
import { createMenu as _createMenu, menus, getMenus } from '../functions/Menus';
import anime from "animejs/lib/anime.es.js";

await getMenus();

const displayForm = ref(false);
const input = ref(null);

watch(input, () => {
    if (input.value && displayForm.value) {
        input.value.focus();
    }
});

async function createMenu(e) {
    e.preventDefault();
    if (input.value) {
        await _createMenu(input.value.value);
        displayForm.value = false;
    }
}

onMounted(() => {
    anime({
        targets: ".menu-list .menu",
        translateY: ["20px", 0],
        scale: [0.98, 1],
        opacity: [0, 1],
        delay: anime.stagger(100),
    });
});


</script>

<template>
    <div class="menu-list">
        <template v-for="menu in menus">
            <router-link class="menu" :to="{ name: 'menus-view', params: { 'menu': menu.slug } }">
                <p class="menu__name">{{ menu.name }}</p>
                <p class="menu__background">{{ menu.name }}</p>
                <p class="menu__link">View Menu</p>
            </router-link>
        </template>
        <div class="menu menu--add" @click="displayForm = true" :class="{ hover: !displayForm }">
            <Transition mode="out-in">
                <form class="menu__form" v-if="displayForm" @submit="createMenu">
                    <input type="text" ref="input" placeholder="Menu name">
                    <div class="button--bordered" value="Create Menu" @click="createMenu">Create Menu</div>
                </form>
                <div class="add" v-else>
                    <svg-vue icon="plus"></svg-vue>
                </div>
            </Transition>
        </div>
    </div>
</template>

<style scoped lang="scss">

.menu-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(550px, 1fr));
    gap: var(--grid-gap);

    .menu {
        position: relative;
        cursor: pointer;
        height: 350px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: none;

        &:nth-child(5n - 4) {
            background: var(--green);
        }

        &:nth-child(5n - 3) {
            background: var(--orange);
        }

        &:nth-child(5n - 2) {
            background: var(--blue-dark);
        }

        &:nth-child(5n - 1) {
            background: var(--blue-mid);
        }

        &:nth-child(5n) {
            background: var(--blue-light);
        }

        &:hover {
            .menu {
                &__name {
                    transform: scale(1.02);
                    opacity: 0;
                }

                &__background {
                    transform: scale(1.02) translateY(-60%);
                    opacity: .5;
                }

                &__link {
                    opacity: 1;
                    bottom: 10%;
                }
            }
        }

        &--add {
            background: var(--grey-light) !important;
            transition: 0.3s filter ease;

            &.hover {
                cursor: pointer;
                transform: none;

                &:hover {
                    filter: brightness(0.9);
                }
            }

            .add {
                width: 64px;
                height: 64px;
                background: #fff;
                padding: 20px;
                border-radius: 100%;
            }
        }

        &__name {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.250em;
            text-transform: uppercase;
            transition: 0.3s ease;

            &:before,
            &:after {
                content: '';
                display: block;
                width: 10px;
                height: 1px;
                background: currentColor;
                margin: 0 5px;
            }
        }

        &__background {
            font-size: 7.5em;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            opacity: .1;
            font-family: var(--script-font);
            pointer-events: none;
            text-align: center;
            line-height: 110px;
            padding: 0 40px;
            transition: 0.3s ease;
        }

        &__link {
            position: absolute;
            opacity: 0;
            text-align: center;
            bottom: 0;
            text-transform: uppercase;
            transition: 0.3s ease;
        }
    }
}
</style>